
<template>
    <div class="xcard">
        <v-btn small class="mt-5" @click="$router.back()" color="info" tile outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>
        <h5 class="text-center"> Listado de Webinars del programa </h5>
        <p class="text-center my-0 purple--text"> {{ programa_name }} </p>

        <v-data-table :headers="headers" :loading="loading" :search="search" :items="desserts" disable-pagination hide-default-footer :items-per-page="5" class="elevation-1">
            <template v-slot:item.sede="{ item }">
                {{ item.sede }}
            </template>
            <template v-slot:item.carga_horaria="{ item }">
                {{ item.carga_horaria }} hrs.
            </template>
            <template v-slot:item.fecha_webinar="{ item }">
                {{ parseDate(item.fecha_webinar) }}
            </template>
            <template v-slot:item.fecha_inicio_matriculacion="{ item }">
                {{ parseDate(item.fecha_inicio_matriculacion) }}
            </template>
            <template v-slot:item.fecha_fin_matriculacion="{ item }">
                {{ parseDate(item.fecha_fin_matriculacion) }}
            </template>

            <template v-slot:item.opt="{ item }"> 
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }"> 
                        <v-btn v-bind="attrs" v-on="on" small @click="openlink(item)" color="green" dark>
                            <v-icon>mdi-link</v-icon>
                        </v-btn>
                    </template>
                    <span> Abrir el link del formularo de registro </span>
                </v-tooltip>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import {getwebinars } from './getWebinars';
import xaxios from '@/xaxios';
  export default {
    data: () => ({
      loading: false, 
      headers: [ 
          { text: 'Webinar', value: 'nombre' },
          { text: 'Carga horaria', value: 'carga_horaria' },
          { text: 'Participantes', value: 'registrados' },
          { text: 'Ciudad', value: 'ciudad_emision' },
          { text: 'Fecha webinar', value: 'fecha_webinar' },
          { text: 'Inicio de registros', value: 'fecha_inicio_matriculacion' },
          { text: 'Fin de registros', value: 'fecha_fin_matriculacion' },
          { text: '', value: 'opt' },
        ],
        desserts:[], 
        search: '',
        programa_id: -1,
        programa_name:'',
    }),
    components: {}, 
    methods: { 
        async getWebinars(){
            this.loading = true;
            this.desserts = [];
            let url = process.env.VUE_APP_WEBINARS_APP;
            window.console.log('url>>>', url);
            let datos = {
                query: getwebinars(this.programa_id),
                variables: {}
            }
            let config = {
                method: 'post',
                url:url,
                headers: { 
                    'Content-Type': 'application/json'
                },
                data: datos
            }
            let res = await xaxios.request(config).then(({data})=>data).catch((e)=>e);
            if(res && res.data){
                let ws = res.data.webinarsByPrograma;
                window.console.log('res>>>', ws);
                if(ws.length == 0 ){
                    this.$root.$notify.show(`este programa no tiene webinars`, { color: 'red', x: 'right' });
                }else{
                    this.desserts = ws;
                }
            }
            this.loading = false;
        },

        parseDate(f, show_hours = true) {
            if (!f) return '-';
            if (!f.includes('T')) f += 'T::';
            const partes = f.split('T');
            const fs1 = partes[0].split('-');
            const fs2 = partes[1].split(':');
            if (show_hours) {
            return `${fs1[2]}/${fs1[1]}/${fs1[0]} ${fs2[0]}:${fs2[1]}`;
            } else {
            return `${fs1[2]}/${fs1[1]}/${fs1[0]}`;
            }
        },
        openlink(item){
            let unidad = this.$store.state.CARGO.sede.unidad_negocio;
            const host = window.location.href + '';
            let cifrado = btoa(item.id)
            let xurl = `/for/webinar/${cifrado}`;
            const datauser = this.$store.state.DATA_USER;
            xurl += `?shared=${datauser.id}`
            
            let url = '';
            if (host.includes('webdev.')) {
                window.open('/webinars/#' + xurl);

            } else {
                if (unidad == 10) url = 'https://dbussinesschool.com/webinars/#' + xurl;
                else if (unidad == 6) url = 'https://cybercorp.com.bo/webinars/#' + xurl;
                else url = 'https://esam.edu.bo/webinars/#' + xurl;
            }

            window.open(url);
        }
    },
    mounted() { 
        this.programa_id = this.$route.query.programaid;
        this.programa_name = this.$route.query.name;
        this.getWebinars();
    },
  };
</script>
